export default "__VITE_ASSET__B6aet2sB__"